<template>
    <div id="sinester-admin">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal"
                 @hidden="resetControlConsulta">

            <!--  CONTROL DE CONSULTA -->
            <control-consulta
                kind_user="admin"
                :role_id="role_id"
                v-show="modalSinisterAdmin"
                ref="controlConsulta"
                :updateRegister="dataRegister">
            </control-consulta>

            <!--  SUBIR FACTURAS  -->
            <upload-invoice
                v-show="modalUploadInvoice"
                :auth_role="role_id"
                :role_id="prov_role_id"
                :reg_id="specialist_id"
                :type_invoice="1"
                :selected_rows="savedSelectedRows"
                :is_sinister="is_sinisters"
                v-on:close="showModal=false">
            </upload-invoice>

        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-md-3 ">
                            <b-pagination
                                :disabled="(specialist_id !== null)"
                                pills align="fill"
                                :hide-goto-end-buttons="true" :limit="3"
                                v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-md-1 cont_select mt-3 mt-md-0">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2 offset-md-4 mt-3 mt-md-0">
                            <div class="filter_content mt-3 float-end">
                                <a class="filterIcon" @click="toggleOpen" :class="{ open: isOpen }" href="#">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </a>
                            </div>
                            <div id="filter_content" class="position-absolute view" v-show="isOpen">
                                <div class="row">
                                    <div class="col-12 col-md-12 cont_select">
                                        <select data-select="on" v-model="prov_role_id" name="ciudad" id="ciudad"
                                                v-on:change="selectCompanyByRoleProvider($event)" class="required">
                                            <option :value="0">Tipo de Proveedor*</option>
                                            <option v-for="prov in providers" :value="prov.id" :key="prov.id">
                                                {{ prov.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-12 col-md-12 mt-4 cont_select">
                                        <select data-select="on" v-model="specialist_id" name="provider" id="provider"
                                                v-on:change="filterBySpecialist()" class="required">
                                            <option :value="null">Proveedor*</option>
                                            <option v-for="lprov in list_providers" :value="lprov.id" :key="lprov.id">
                                                {{ lprov.genericName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-12 col-md-12 mt-4 cont_select">
                                        <select id="sinister_status_paid" class="float" v-model="params.status"
                                                v-on:change="filterStatusSinister()">
                                            <option :value="null">Todas</option>
                                            <option :value="0">Sin. sin pagar C/F</option>
                                            <option :value="1">Sin. sin pagar S/F</option>
                                            <option :value="2">Sin. Sin Factura</option>
                                            <option :value="3">Sin. Pagados S/F</option>
                                            <option :value="4">Sin. Pagados C/F</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="role_id===1" class="col-12 col-md-2 mt-3 mt-md-0">
                            <button v-if="savedSelectedRows.length===0" type="button" class="formSubmit"
                                    v-on:click="openModalsProviders('admin_sinester')">Agregar
                            </button>
                            <div v-if="savedSelectedRows.length>0">
                                <button type="button" class="formSubmit"
                                        v-on:click="openModalsProviders('upload_bill_admin')">
                                    Facturar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table sticky-header="100vh" stacked="md" id="my-table" striped hover :fields="fields"
                                 :busy="isBusy" :items="pagination.data" :filter="filter" :select-mode="selectMode"
                                 selectable @row-selected="onRowSelected" no-select-on-click ref="selectableTable">
                            <template #head(acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #head(factura)="{item}">
                                <i class="fa-solid fa-file-invoice-dollar"></i>
                            </template>
                            <template #cell(facturar)="{ rowSelected, index, item }" v-if="specialist_id!==null">
                                <button class="badge rounded-pill border-0"
                                        :class="rowSelected?'text-bg-green':'text-bg-orange'"
                                        v-if="item.invoice_id===null"
                                        @click="clickRow(index, item, rowSelected)">
                                    <i class="fa-solid fa-angles-up"></i>
                                </button>
                            </template>
                            <!-- A virtual column -->
                            <template #cell(paciente)="{item}">
                                <span>{{ item.id }}</span>
                            </template>
                            <template #cell(atendido_por)="{item}">
                                <span>{{ item.specialist_name }}</span>
                            </template>
                            <template #cell(paciente)="{item}">
                                <span v-if="item.papanicolau_serv" class="badge rounded-pill papanicolau">{{
                                        item.sku
                                    }}</span>
                                <span v-else>{{ item.sku }}</span>
                            </template>
                            <template #cell(fecha_atencion)="{item}">
                                <span>{{ formatDate(item.fecha_atencion) }}</span>
                            </template>
                            <template #cell(pdf)="{item}">
                                <span v-if="item.pdf">
                                    <a :href="'../storage/siniestro/'+item.pdf" class="badge rounded-pill text-bg-blue"
                                       target="_blank">
                                        <i class="fas fa-file-pdf"></i>
                                    </a>
                                </span>
                            </template>
                            <template #cell(paquete)="{item}">

                                <span title="Diamante" v-if="item.paquete==='D'" class="badge rounded-pill pkg_diamond">
                                    Diamante
                                </span>
                                <span title="Platino" v-if="item.paquete==='P'" class="badge rounded-pill pkg_platinum">
                                    Platino
                                </span>
                                <span title="Gold" v-if="item.paquete==='G'" class="badge rounded-pill pkg_gold">
                                    Gold
                                </span>
                                <span title="Silver" v-if="item.paquete==='S'" class="badge rounded-pill pkg_silver">
                                    Silver
                                </span>

                            </template>
                            <template #cell(factura)="{item}">
                                <a target="_blank" v-if="item.invoice_id"
                                   :href="'/storage/especialistas/facturas/'+item.supplier_id+'/'+item.relinvoice.factura_name+'.pdf'"
                                   class="badge rounded-pill text-bg-green">
                                    <i class="fa-solid fa-file-invoice-dollar"></i>
                                </a>
                                <span v-else class="badge rounded-pill text-bg-gray">
                                    <i class="fa-solid fa-file-invoice-dollar"></i>
                                </span>
                            </template>
                            <template #cell(pago)="{item}">
                                <a v-if="item.paid_at === 1 && item.relinvoice && item.relinvoice.tickets" :href="'/storage/especialistas/tickets/'+item.supplier_id+'/'+item.relinvoice.tickets[0].ticketImg"
                                   class="badge rounded-pill text-bg-green">
                                    <i class="fa-solid fa-receipt"></i>
                                </a>

                                <span v-else class="badge rounded-pill text-bg-gray">
                                    <i class="fa-solid fa-receipt"></i>
                                </span>
                            </template>
                            <template #cell(acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="updateRegister(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="print_pdf(item.id)">Imprimir</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="auth_serv(item.id)">Aut.
                                            Serv. Ex.</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="deleteOne(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col col-xl-3">
                            <b-pagination
                                :disabled="(specialist_id !== null)"
                                pills align="fill"
                                :hide-goto-end-buttons="true"
                                :limit="3"
                                v-model="pagination.current_page"
                                :total-rows="pagination.total"
                                :per-page="pagination.per_page"
                                aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {sinisterService} from "../../Services/Sinister.service";
import {supplierspecialistService} from "../../Services/SupplierSpecialist.service";
import {rolesService} from "../../Services/Roles.service";
import {supplierambulancesService} from "../../Services/SupplierAmbulances.service";
import {supplierinstitutionsService} from "../../Services/SupplierInstitutions.service";
import {supplierlaboratoriesService} from "../../Services/SupplierLaboratories.service";
import {supplierdentistsService} from "../../Services/SupplierDentists.service";
import {supplierradiologyService} from "../../Services/SupplierRadiologia.service";
import {supplieropticiansService} from "../../Services/SupplierOpticians.service";

export default {
    name: "sinester-admin",
    mixins: [myMixins],
    props: {
        role_id: {
            type: Number,
            comments: 'Este role_id se usa en el control de consulta para activar o desactivar si la consulta esta pagada o no',
            required: true
        },
    },
    data() {
        return {
            isOpen: false,
            selectMode: 'multi',
            prov_role_id: 0,
            specialist_id: null,
            inst_id: 0,
            isBusy: false,
            filter: null,
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {key: 'facturar'},
                {key: 'id'},
                {key: 'atendido_por'},
                {key: 'paciente'},
                {key: 'fecha_atencion'},
                {key: 'pdf'},
                {key: 'paquete'},
                {key: 'factura'},
                {key: 'pago'},
                {key: 'acciones'},

            ],
            specialists: [],
            savedSelectedRows: [],
            selectedRows: [],
            originalData: [],
            providers: [],
            list_providers: [],
            params: {
                limit: 10,
                page: 1,
                status: null
            },
            dataRegister: {},
            is_sinisters: true,
        }
    },
    methods: {
        async auth_serv(id) {
            let resp = await sinisterService.authServ(id);
            this.getAlert(resp.process);
        },
        async deleteOne(id) {
            let resp = await sinisterService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async filterStatusSinister() {
            // Crear una copia de this.originalData
            let dataCopy = [...this.originalData];

            switch (this.params.status) {
                case 0:
                    //Siniestros sin pagar C/F
                    dataCopy = dataCopy.filter((item) => item.invoice_id !== null && item.paid_at === 0);
                    break;
                case 1:
                    //Siniestros sin pagar S/F
                    dataCopy = dataCopy.filter((item) => item.invoice_id === null && item.paid_at === 0);
                    break;
                case 2:
                    //Siniestros S/F
                    dataCopy = dataCopy.filter((item) => item.invoice_id === null);
                    break;
                case 3:
                    //Siniestros Pagados S/F
                    dataCopy = dataCopy.filter((item) => item.invoice_id === null && item.paid_at === 1);
                    break;
                case 4:
                    //Siniestros Pagados C/F
                    dataCopy = dataCopy.filter((item) => item.invoice_id !== null && item.paid_at === 1);
                    break;
                default:
                    this.params.status = null;
                    break;
            }

            if (dataCopy.length === 0) {
                this.getAlert('no_data');
            } else {
                this.pagination.data = dataCopy;
            }
            // Actualizar this.pagination.data con los datos filtrados

        },
        async filterBySpecialist() {

            //console.log('prov_role_id', this.prov_role_id);
            this.params.status = null;

            if (this.specialist_id === null) {
                this.params = {
                    limit: 10,
                    page: 1,
                    status: null
                }
                //console.log('entro al if para volver a cargar todos los registros y activar la paginacion');
                await this.index();
            } else {
                this.isBusy = true;
                this.params.limit = 0;
                this.params.where = [
                    {
                        field: 'model_type',
                        operator: '=',
                        value: 'App\\Models\\' + this.roleModels[this.prov_role_id],
                    }, {
                        field: 'supplier_id',
                        operator: '=',
                        value: this.specialist_id,
                    }
                ];
                if (this.params.status !== null) {
                    this.params.where.push({
                        field: 'paid_at',
                        operator: '=',
                        value: this.params.status,
                    });
                }
                this.pagination.data = await sinisterService.getMany(this.params);
                if (this.pagination.data.length === 0) {
                    this.getAlert('no_data');
                } else {
                    this.originalData = [...this.pagination.data];
                }
                this.isBusy = false;
            }


        },
        async getProvidersByRole(id) {
            switch (Number(id)) {
                /* case 3:
                     return supplierambulancesService.getMany({});*/
                case 4:
                    return supplierspecialistService.getMany({});
                /* case 7:
                     return supplierinstitutionsService.getMany({});*/
                /* case 10:
                     return supplierlaboratoriesService.getMany({});*/
                case 11:
                    return supplierdentistsService.getMany({});
                /*case 12:
                    return supplierradiologyService.getMany({});*/
                /*case 13:
                    return supplieropticiansService.getMany({});*/
                default:
                    return [];
            }
        },
        async index() {
            //console.log('entro al index');
            this.isBusy = true;
            this.providers = await rolesService.getProvidersForSinester();
            this.specialists = await supplierspecialistService.getMany();
            this.pagination = await sinisterService.getMany(this.params);
            this.isBusy = false;
        },
        async print_pdf(id) {
            this.isBusy = true;
            let resp = await sinisterService.printSinister(id);
            this.getAlert(resp.process);
            //this.pagination = await quotersService.getMany(this.params);
            this.isBusy = false;
        },
        async selectCompanyByRoleProvider($e) {
            let id = this.stateId($e);
            let columnName = this.columnMapping[Number(id)];

            if (columnName) {
                let providers = await this.getProvidersByRole(id);
                // Procesa el nombre de la columna según sea necesario
                this.list_providers = this.processColumnNames(providers, columnName);
            }
        },
        async updateRegister(data) {
            //console.log('data enviada al hijo', data);
            await this.$nextTick(() => {
                //console.log('actualizo la variable')
                if (this.$refs.controlConsulta) {
                    //console.log('compruebo que exista el ref');
                    this.$refs.controlConsulta.modificar = true;
                    //console.log('actualizo la variable a true');
                }
            });
            //console.log('abro el modal');
            this.openModalsProviders('admin_sinester');
            this.dataRegister = data;

        },
        changeLimit() {
            this.index();
        },
        clickRow(index, item, rowSelected) {
            console.log('index', index, 'item', item, 'rowSelected', rowSelected);
            if (rowSelected) {
                this.$refs.selectableTable.unselectRow(index);
            } else if (item.paid_at !== 1) {
                this.theRowSelected = true;
                this.$refs.selectableTable.selectRow(index);
            }
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        onRowSelected(items) {
            this.kind_bill = 1;
            //console.log('onRowSelected', items);
            //FILTRO LOS REGISTROS QUE NO ESTAN PAGADOS
            this.selectedRows = items.filter((item) => item.paid_at === 0);
            //GUARDO EL ID DEL SINIESTRO Y EL ID DEL PROVEEDOR
            //SE LE QUITO EL item.supplier_id por que ya se esta mandando el tado por prop
            this.savedSelectedRows = this.selectedRows.map((item) => [item.id]);
        },
        processColumnNames(providers, columnName) {
            return providers.map(provider => ({
                id: provider.id,
                genericName: provider[columnName],
            }));
        },
        resetControlConsulta() {
            this.$nextTick(() => {
                //console.log('executo al cierre del modal');
                if (this.$refs.controlConsulta) {
                    //console.log('valido la accion de cierre');
                    this.$refs.controlConsulta.modificar = false;
                    //console.log('this.$refs.controlConsulta', this.$refs.controlConsulta);
                }
            });
        },
        toggleOpen() {
            this.isOpen = !this.isOpen;
        }
    },
    async mounted() {
        await this.index();
    }
}
</script>

